<div class="info-container mat-elevation-z2">
  <div class="section-container">
    <h1 class="title">Planned System Outage</h1>
    <p class="details">{{ plannedOutage }}</p>
  </div>
  <div class="section-container">
    <h1 class="title">Release Notes</h1>
    @if (appVersion !== '') {
      <h2 class="release-notes-version">Current Version: {{ appVersion }}</h2>
    }
    <div class="release-notes-accordion">
    @for (note of notes; track note.version) {
      <div class="release-notes-accordion-item">       
          <span class="release-notes-accordion-item-title">
            <h2>Version {{ note.version }}</h2>
          </span>
          <span class="release-notes-accordion-item-date">
            {{ note.date }}
          </span>
  
        <ul>
          @for (item of note.highlights; track item) {
            <li>{{ item }}</li>
          }
        </ul>
  
        @if (note.details) {
          <p class="details">{{ note.details }}</p>
        }
      </div>
    }
    </div>
  </div>
</div>
  